import { Routes, Route } from 'react-router-dom';
import PprDashboard from './PprDashboard';
import PprJobDetail from './PprJobDetail';

/**
 * /ppr/*  — Post Project Review module
 *
 *   /ppr          → Pipeline dashboard (all PPRs by status)
 *   /ppr/:jobId   → Job detail (4 tabs: Contacts, Financials, Report, Notes)
 */
export default function PprPage() {
  return (
    <Routes>
      <Route index element={<PprDashboard />} />
      <Route path=":jobId" element={<PprJobDetail />} />
    </Routes>
  );
}
